module.exports = __webpack_public_path__ + "static/img/企业文化2.bbb1a777.png";